import React from 'react'

const PageNotFound = () => {
    return (
        <div className="flex items-center justify-center min-h-screen bg-[#025D89]">
          <div className="bg-white shadow-lg rounded-lg p-8 max-w-lg text-center border-t-8 border-[#E73921]">
            <img 
            //   src={notFoundImage} 
            //   alt="404 Error" 
            //   className="mx-auto mb-6 rounded-md shadow-md"
            />
            <h1 className="text-5xl font-bold text-[#E73921] mb-4">404 ERROR</h1>
            <p className="text-[#025D89] text-lg font-semibold mb-6">
              Sorry, the page you are looking for cannot be found.
            </p>
            <a 
              href="/dashboard" 
              className="px-6 py-3 bg-[#E73921] text-white font-semibold rounded-md shadow-md hover:bg-[#b52b19] transition duration-300"
            >
              Back to Main Page
            </a>
          </div>
        </div>
      );
}

export default PageNotFound
